<div class="h-100 position-relative" [appStoryblok]="_editable">
  <a *ngIf="link && image.filename" class="d-block" [storyblokLink]="link">
    <img width="200" height="250" class="w-100" [ngSrc]="image.filename" />
  </a>
  <img
    *ngIf="!link && image.filename"
    width="200"
    height="250"
    class="w-100"
    [ngSrc]="image.filename"
  />

  <div
    [ngClass]="{ 'mt-3': image.filename }"
    *ngIf="name || (link && linktext)"
    class="d-flex flex-column h-100"
  >
    <h2 *ngIf="name" class="h5 fw-600">{{ name }}</h2>
    <div *ngIf="content" class="content" [storyblokRichText]="content"></div>
    <div class="link">
      <a *ngIf="link && linktext" [storyblokLink]="link">{{ linktext }}</a>
    </div>
  </div>
</div>
